"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SurveySearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return SurveySearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _base = require("../../base");
const SurveySearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("survey"),
    name_re: _zod.z.string().optional(),
    status_eq: _zod.z.string().optional()
});
